import React, { useState, useEffect, useRef } from 'react';
import { useStateCallback } from '../../utils/stateCallback';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Button from 'react-bootstrap-button-loader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { getAllMaterialResource, deleteMaterial, getMaterialResourceByTimesheetId } from '../../actions/materialResource';
import * as StatusCode from '../../scripts/StatusCode';
import * as MaterialType from '../../scripts/MaterialResourceTypeMode';
import { formatDate, toDisplayDecimal } from '../../utils'
import { IsEnglish } from '../../utils/language';
import AlertAlgo from '../controls/AlertSnack'
import styles from '../../styles/materialResource.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashXmark } from "@fortawesome/pro-duotone-svg-icons";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    icons: {
        color: '#3f51b5 !important'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1
    }
}));

export function MaterialResourceList(props) {    
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [materialId, setMaterialId] = useState(0);
    const [timesheetData, setTimesheetData] = useStateCallback(null);
    const [typeMode, setTypeMode] = useStateCallback(null);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

    const alertRef = useRef(null);

    useEffect(() => {
        if (typeMode != null && typeMode == MaterialType.Type_Material) {
            loadList();
        }
    }, [typeMode]);

    useEffect(() => {
        if (props.typeMode != null) {
            setTypeMode(props.typeMode);
        }
    }, [props.typeMode]);

    useEffect(() => {
        if (props.event.reload && props.typeMode === MaterialType.Type_Material) {
            loadList();
        }
        if (props.event.reload && props.typeMode === MaterialType.Type_Timesheet) {
            loadList(props.event.timesheetData);
        }
    }, [props.event, props.typeMode]);

    useEffect(() => {
        if (props.timesheetData != null) {
            setTimesheetData(props.timesheetData);
        }
    }, [props.timesheetData]);

    useEffect(() => {
        if (typeMode === MaterialType.Type_Timesheet && timesheetData != null) {
            loadList(timesheetData);
        }
    }, [timesheetData, typeMode]);


    const loadList = (timesheetData) => {
        return new Promise(async (resolve) => {
            var response = typeMode === MaterialType.Type_Material ?
                await getAllMaterialResource()
                : await getMaterialResourceByTimesheetId(timesheetData.timesheetId);

            if (response != null && response.status == StatusCode.STATUS_OK) {
                setData(response);
            } else {
                showMessageError(i18next.t('error:generic-error'));
            }
            resolve();
        })
    }

    const handleOpenMaterial = (id) => {
        if (id > 0) {
            const material = data.filter(x => x.MaterialResourceId == id)[0];

            if (material == null) {
                showMessageError(i18next.t('error:generic-error'));
                return;
            }

            props.setEvent({ edit: true, id: id, data: material });
        } else {
            props.setEvent({ add: true });
        }
    }

    const handleOpenConfirmDelete = (id) => {
        setMaterialId(id);
        setOpenConfirmDelete(true);
    }

    const handleCloseConfirmDelete = () => {
        setOpenConfirmDelete(false);
    }

    const handleDelete = async () => {
        if (materialId > 0) {
            const response = await deleteMaterial(materialId);

            if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
                return;
            }

            setOpenConfirmDelete(false);
            showMessageSuccess(i18next.t('common:deleteMessage'));
            loadList(timesheetData);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    return (
        <div className={styles.konekCard}>
            {data && data.map((obj, index) =>
                <React.Fragment key={index}>
                    <ListItem key={index} button className="listItem" onClick={() => handleOpenMaterial(obj.MaterialResourceId)}>
                        <ListItemText disableTypography={true} primary={
                            <React.Fragment>
                                <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.date')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>{formatDate(obj.Date, 'date')}</span>
                                </div>
                                <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.materialResourceCode')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>{`${obj.ResourceCode} - ${IsEnglish() ? obj.MaterialResourceCodeE : obj.MaterialResourceCodeF}`}</span>
                                </div>
                                <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.unit')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>{obj.PayUnit}</span>
                                </div>
                                <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.quantity')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>{toDisplayDecimal(obj.Quantity)}</span>
                                </div>
                                {obj.ABCProjectCode && <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.project')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>
                                        {`${obj.ABCProjectCode} - ${IsEnglish() ? obj.ProjectABCE : obj.ProjectABCF}`}
                                    </span>
                                </div>}
                                {obj.ABCActivityCode != null && <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.activity')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>
                                        {`${obj.ABCActivityCode} - ${IsEnglish() ? obj.ActivityABCE : obj.ActivityABCF}`}
                                    </span>
                                </div>}
                                {obj.ProjectCode && <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.project')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>
                                        {`${obj.ProjectCode} - ${IsEnglish() ? obj.ProjectPayE : obj.ProjectPayF}`}
                                    </span>
                                </div>}
                                {obj.ActivityCode && <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.activity')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>
                                        {`${obj.ActivityCode} - ${IsEnglish() ? obj.ActivityPayE : obj.ActivityPayF}`}
                                    </span>
                                </div>}
                                {obj.TaskCode && <div>
                                    <span className={classes.spanLabel}>{`${i18next.t('materialResource:form.task')}${i18next.t('common:labelSeparator')}`}</span>
                                    <span className={classes.spanValue}>
                                        {`${obj.TaskCode} - ${IsEnglish() ? obj.TaskE : obj.TaskF}`}
                                    </span>
                                </div>}
                            </React.Fragment>
                        } />
                        <ListItemSecondaryAction className={classes.divAction}>
                            <IconButton className={classes.icons} edge="end" aria-label="delete" onClick={() => handleOpenConfirmDelete(obj.MaterialResourceId)}>
                                <FontAwesomeIcon icon={faTrashXmark} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                </React.Fragment>
            )}
            <Dialog
                open={openConfirmDelete}
                onClose={handleCloseConfirmDelete}
                aria-labelledby="draggable-dialog-title"
                style={{ zIndex: 10001 }}
            >
                <DialogTitle id="draggable-dialog-title">
                    Confirmation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('common:confirmDelete')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmDelete} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                    <Button autoFocus onClick={() => handleDelete()} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                </DialogActions>
            </Dialog>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['menu', 'materialResource', 'common', 'error'], { wait: true })(MaterialResourceList);